import { isMain, isStaging } from "./config";

export function getEnterpriseApiEndpoint() {
	const url = process.env.ZIG_API_URL;

	if (!url) throw new Error("env ZIG_API_URL not found");

	return url;
}

export function getReservationApiEndpoint() {
	const url = process.env.ZIG_API_RESERVATION_URL;

	if (!url) throw new Error("env ZIG_API_RESERVATION_URL not found");

	return url;
}

export function getDeliveryStoreApiEndpoint() {
	if (isMain) {
		return {
			auth: "https://api-auth.delivery.zigcore.com.br",
			client: "https://api-client.delivery.zigcore.com.br",
			order: "https://api-order.delivery.zigcore.com.br",
			partner: "https://api-partner.delivery.zigcore.com.br",
			store: "https://api-store.delivery.zigcore.com.br",
			reservation: "https://api-reservation.delivery.zigcore.com.br/",
		};
	}

	const environment = isStaging ? "stg" : "develop";

	return {
		auth: `https://${environment}-api-auth.delivery.zigpay.dev`,
		client: `https://${environment}-api-client.delivery.zigpay.dev`,
		order: `https://${environment}-api-order.delivery.zigpay.dev`,
		partner: `https://${environment}-api-partner.delivery.zigpay.dev`,
		store: `https://${environment}-api-store.delivery.zigpay.dev`,
		reservation: `https://${environment}-api-reservation.delivery.zigpay.dev/`,
	};
}
